import React from 'react'
import { Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import NotFoundImg from "../../../../../../assets/images/not-found.png"
import Intercom from "../../../../../../assets/images/Intercom.png"

const NotFound = ({ errorText }) => {
    const useStyles = makeStyles((theme) => styles(theme));
    const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.textContainer}>
      <Typography className={classes.title}
      variant="h2"
      color="textPrimary">We're sorry - we can't find the page you're looking for.</Typography>
      <Typography className={classes.question} variant='body2'>What could have caused this?</Typography> 
      <Typography className={classes.text} variant='body2'>The {errorText} you’re looking for may have been deleted.</Typography>
      <Typography className={classes.text}  variant='body2'>The {errorText} you are trying to access doesn't exist </Typography>
      <Typography className={classes.text} variant='body2'>You may have accidentally typed the wrong URL in the address bar. </Typography>
      <Typography className={classes.question} variant='body2'>What can you do?</Typography>
      <Typography className={classes.text} variant='body2'>Retype the URL.</Typography>
      <Typography className={classes.text} variant='body2'>Try refreshing the page.</Typography>
      <Typography className={classes.text} variant='body2'>Go to the <Link to="/map" className={classes.link} >LandHawk homepage</Link>.</Typography>
      <Typography className={classes.text} variant='body2'>Go to the <Link to="/dashboard" className={classes.link} >workspace</Link>.</Typography>
      </div>
      <img className={classes.image} src={NotFoundImg} alt="" />
      <Typography className={classes.contact} variant='body2'>Still having issues? Contact us here >> </Typography>
      <img className={classes.intercom} src={Intercom} alt="" />
    </div>
  )
}

const styles = theme => ({
    root: {
        backgroundColor: "#505A5C",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: `92vh`,
        color: "#fff",
        textAlign: "left",
        paddingLeft: 100,
        paddingRight: 100,
    },
    textContainer: {
      height: `100vh`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: `40vw`,
      alignItems: "flex-start",
      paddingLeft: 30,
      paddingTop: 200
    },
    title: {
      // marginRight: `50px`,
      fontSize: 48,
      fontWeight: 400,
      paddingBottom: 40,
      lineHeight: 1
    },
    text:{
      fontSize: 28,
      fontWeight: 400,
      paddingBottom: 30,
      lineHeight: 1
    },
    contact:{
      position: "absolute",
      lineHeight: 1,
      bottom: 20,
      right: 75,
      fontSize: 28,
      fontWeight: 400,
    },
    question:{
      fontSize: 28,
      fontWeight: 500,
      paddingBottom: 30,
      lineHeight: 1
    },
    link: {
      color: "#9ed6de",
      textDecoration: "none",
      "&:visited": {
        color: "#9ed6de",
        textDecoration: "none"
      }
    },
    intercom: {
      width: 48,
      height: 48,
      position: "absolute",
      bottom: 10,
      right: 10
    },
    image: {
      // marginLeft: `50px`,
    },
})

export default NotFound
